import * as React from 'react';

import { ChatMessageGroup } from '../components/MessageGroup';
import { logError } from '../helpers/logging';
import {
	getMessageGroupsContainingMessagesOfType,
	getMessageGroupsOfSenderType,
} from '../helpers/state';
import {
	ChatMessageTypes,
	ChatMode,
	LiveChatStatus,
	SenderTypes,
	State,
} from '../store';

export type UseLoggerProps = Partial<State>;

export function useLogger({
	chatMode,
	liveChatStatus,
	chatHistory,
	liveChatAgent,
	showLiveChatAutoDisconnectNotice,
	liveChatActivationData,
}: UseLoggerProps): void {
	// React.useEffect(() => {
	// 	/**
	// 	 * When avatar of the most recent message from active agent shows disconnected
	// 	 * even though global live chat status is connected
	// 	 */
	// 	if (
	// 		chatMode === ChatMode.LiveChat &&
	// 		liveChatStatus === LiveChatStatus.Connected &&
	// 		liveChatAgent &&
	// 		liveChatAgent.isConnected === true &&
	// 		chatHistory &&
	// 		chatHistory.length
	// 	) {
	// 		const allLiveChatAgentMessageGroups = getMessageGroupsOfSenderType(
	// 			chatHistory,
	// 			SenderTypes.LiveChat
	// 		);
	// 		const allLiveChatAgentMessages = getMessageGroupsContainingMessagesOfType(
	// 			allLiveChatAgentMessageGroups,
	// 			ChatMessageTypes.Simple
	// 		);
	// 		const lastLiveChatAgentMessageGroup: ChatMessageGroup | null = allLiveChatAgentMessages.length
	// 			? allLiveChatAgentMessages[allLiveChatAgentMessages.length - 1]
	// 			: null;

	// 		if (
	// 			liveChatActivationData &&
	// 			lastLiveChatAgentMessageGroup &&
	// 			lastLiveChatAgentMessageGroup.liveChatAgent &&
	// 			lastLiveChatAgentMessageGroup.liveChatAgent.isConnected === false
	// 		) {
	// 			logError(
	// 				'Avatar of the most recent message from active agent shows disconnected when chat status is connected',
	// 				{ liveChatActivationData }
	// 			);
	// 		}
	// 	}
	// }, [
	// 	chatHistory,
	// 	chatMode,
	// 	liveChatActivationData,
	// 	liveChatAgent,
	// 	liveChatStatus,
	// ]);

	// React.useEffect(() => {
	// 	/**
	// 	 * When latest agent message group has a different agent than the global agent
	// 	 */
	// 	if (
	// 		chatMode === ChatMode.LiveChat &&
	// 		liveChatStatus === LiveChatStatus.Connected &&
	// 		liveChatAgent &&
	// 		chatHistory &&
	// 		chatHistory.length
	// 	) {
	// 		const allLiveChatAgentMessageGroups = getMessageGroupsOfSenderType(
	// 			chatHistory,
	// 			SenderTypes.LiveChat
	// 		);
	// 		const allLiveChatAgentMessages = getMessageGroupsContainingMessagesOfType(
	// 			allLiveChatAgentMessageGroups,
	// 			ChatMessageTypes.Simple
	// 		);
	// 		const lastLiveChatAgentMessageGroup: ChatMessageGroup | null = allLiveChatAgentMessages.length
	// 			? allLiveChatAgentMessages[allLiveChatAgentMessages.length - 1]
	// 			: null;

	// 		if (
	// 			liveChatActivationData &&
	// 			lastLiveChatAgentMessageGroup &&
	// 			lastLiveChatAgentMessageGroup.liveChatAgent &&
	// 			lastLiveChatAgentMessageGroup.liveChatAgent.participantId !==
	// 				liveChatAgent.participantId
	// 		) {
	// 			logError(
	// 				'Latest agent message group has a different agent than the global agent',
	// 				{
	// 					liveChatActivationData,
	// 					liveChatAgent,
	// 					lastLiveChatAgentMessageGroupAgent:
	// 						lastLiveChatAgentMessageGroup.liveChatAgent,
	// 				}
	// 			);
	// 		}
	// 	}
	// }, [
	// 	chatHistory,
	// 	chatMode,
	// 	liveChatActivationData,
	// 	liveChatAgent,
	// 	liveChatStatus,
	// ]);

	React.useEffect(() => {
		/**
		 * When we receive an auto disconnect notice, but the live chat status is NOT connected.
		 */
		if (
			liveChatActivationData &&
			chatMode === ChatMode.LiveChat &&
			showLiveChatAutoDisconnectNotice &&
			(liveChatStatus === LiveChatStatus.Connecting ||
				liveChatStatus === LiveChatStatus.Transferring)
		) {
			logError('Auto disconnect notice displayed incorrectly', {
				liveChatActivationData,
				liveChatStatus,
			});
		}
	}, [
		chatMode,
		liveChatActivationData,
		liveChatStatus,
		showLiveChatAutoDisconnectNotice,
	]);

	React.useEffect(() => {
		/**
		 * When live chat fails to start
		 */
		if (
			liveChatActivationData &&
			liveChatStatus === LiveChatStatus.ConnectionError
		) {
			logError('Live chat connection error', { liveChatActivationData });
		}
	}, [liveChatActivationData, liveChatStatus]);
}

export default useLogger;
